// extracted by mini-css-extract-plugin
module.exports = {"memberImage":"styles_memberImage__1hOPx","subtitle":"styles_subtitle__3SzQd","description":"styles_description__3Ltuy"};